import { render, staticRenderFns } from "./Scholarity.vue?vue&type=template&id=292422df&"
import script from "./Scholarity.vue?vue&type=script&lang=js&"
export * from "./Scholarity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports